<script>
import axios from 'axios';

import ModalDialog from './ModalDialog.vue'

import {IotServers} from '../api.js'

export default {
	mounted: function () {
		this.api.query(IotServers).updated((result) => {
			this.servers = result
		})
	},
	components: {
		'modal-dialog': ModalDialog
	},
	name: "Servers",
	data: function () {
		return {
			certChain: {},
			closingServer: null,
			defaultContext: false,
			interval: null,
			password: "",
			secure: false,
			serverId: "",
			servers: [],
			serverUrl: "/api/server",
			serversUrl: "/api/servers"
		};
	},
	destroyed: function () {
		if (typeof this.interval !== "undefined") {
			clearInterval(this.interval);
		}
	},
	methods: {
		createServer: function () {
			let serverId = this.serverId;
			let parameters = null;
			const use_default_ctx = this.defaultContext;

			if (!serverId) {
				alert("Server ID is required");
			}
			else {
				parameters = {
					ssl: {}
				};
				if (this.secure) {
					if (!use_default_ctx) {
						if (this.certChain.certificate && this.certChain.private_key) {
							this.certChain.passphrase = this.password;
							parameters.ssl = {
								cert_chain: this.certChain
							};
						}
						else {
							alert("Certificate and private key are required for secure servers.");
							parameters = null;
						}
					}
				}
				else {
					parameters.ssl = null;
				}
			}
			if (parameters) {
				axios.post(this.serversUrl, {
					name: serverId,
					protocol: 'weblink',
					port: null,
					protocol_parameters: parameters
				}).catch(function (error) {
					let response_json = error.response.data;
					let status_text = response_json.status.toUpperCase();
					alert(status_text + ": " + response_json.result.error);
				});
			}
		},
		removeServer: function () {
			return axios.delete(`${this.serverUrl}/${this.closingServer.id}`)
		},
		setCertificate: function (e) {
			let file = e.target.files[0];
			this.setChain(file, 'certificate');
		},
		setClosingServer: function (server) {
			this.closingServer = server;
		},
		setKey: function (e) {
			let file = e.target.files[0];
			this.setChain(file, 'private_key');
		},
		setChain: function (file, attribute) {
			let self = this;
			let reader = new FileReader();
			reader.addEventListener("load", function () {
				self.certChain[attribute] = reader.result;
			}, false);

			if (file) {
				reader.readAsText(file);
			}
		}
	},
	props: {
		api: Object,
	}
};
</script>
<template>
	<div>
		<modal-dialog button="Close"
			header="Close Server?" id="closeModal" v-bind:onAccept="removeServer">
			<p>This will permanently remove this server.</p>
		</modal-dialog>

		<table id="server-table" class="striped row s12">
			<thead>
				<tr>
					<th>Name</th>
					<th>URL</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="server in servers"
					v-bind:key="server.id"
					v-bind:server="server">
					<td><router-link v-bind:to="'/servers/' + server.id">{{ server.id }}</router-link></td>
					<td>{{ server.url }}</td>
					<td>
						<button
							:disabled="server.permanent" class="btn modal-trigger red" 
							data-target="closeModal" v-on:click="setClosingServer(server)">Close</button>
					</td>
				</tr>
				</tbody>
			</table>

			<div class="row">
				<span class="s4 col input-field">
					<input type="text" placeholder="A Unique Server ID" v-model="serverId">
				</span>
				<span class="s3 col input-field">
						<label for="secure">
							<input class="filled-in" id="secure" type="checkbox" checked="checked" v-model="secure">
								<span>Secure</span>
						</label>
					</span>
					<span class="s3 col input-field">
							<label for="default" v-show="secure">
								<input class="filled-in" id="default" type="checkbox" checked="checked" v-model="defaultContext">
								<span>Default Certificates</span>
							</label>
					</span>
					<span class="s2 col input-field">
						<button class="waves-effect waves-light btn" v-on:click="createServer">Create</button>
					</span>
			</div>

			<div v-show="secure && !defaultContext">
				<em>Keep in mind that this information is sent over insecure HTTP. Please only use test
					certificates.</em>
				<div class="row">
					<div class="s4 col file-field input-field">
						<div class="btn">
							<span>Certificate</span>
							<input type="file" v-on:change="setCertificate($event)">
						</div>
						<div class="file-path-wrapper">
							<input class="file-path validate" type="text">
						</div>
					</div>
					<div class="s4 col file-field input-field">
						<div class="btn">
							<span>Private Key</span>
							<input type="file" v-on:change="setKey($event)">
						</div>
						<div class="file-path-wrapper">
							<input class="file-path validate" type="text">
						</div>
					</div>
					<div class="s4 col input-field">
						<input id="password" type="text" v-model="password">
						<label for="password">Password</label>
					</div>
				</div>
			</div>
		</div>
	</template>
